export const APP_DEFAULT_LANGUAGE = "en";
export const APP_DEFAULT_THEME = "light";

export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const USER_TYPE = {
  STUDENT: { LABEL: "Student", ROLE: "student", ID: 1 },
  PARENT: { LABEL: "Parent", ROLE: "parent", ID: 2 },
  SCHOOL: { LABEL: "School", ROLE: "school", ID: 3 },
  TEACHER: { LABEL: "Teacher", ROLE: "teacher", ID: 4 },
  KID: { LABEL: "Kid", ROLE: "kid", ID: 5 },
  SUPERADMIN: { LABEL: "Super Admin", ROLE: "admin" },
};

export const STATUS_LABELS = {
  1: "pending",
  2: "submitted",
  3: "approved",
  4: "rejected",
  5: "resubmitted",
};

export const LANGUAGE_VERSIONS = {
  javascript: "18.15.0",
  typescript: "5.0.3",
  python: "3.10.0",
  java: "15.0.2",
  csharp: "6.12.0",
  php: "8.2.3",
  html: "5.0", // Add HTML version
  css: "3.0", // Add CSS version
};

export const NOTIFICATION_KEYS = {
  WELCOME: "welcome", // not clickable
  RESET_QUESTIONS: "reset-questions", // clickable to lesson questions
  RESET_CHALLENGES: "reset-challenges", // not clickable
  RESET_LESSON: "reset-project", // clickable to levels project
  FINISH_LESSON: "finish-lesson", // not clickable
  APPROVED_PROJECT: "approved-project", // clickable to project ide
  REJECTED_PROJECT: "rejected-project", // clickable to project ide
  APPROVED_LEVEL_PROJECT: "approved-level-project", // clickable to project ide
  REJECTED_LEVEL_PROJECT: "rejected-level-project", // clickable to project ide
  TROPHY_TAKEN: "trophy-taken", // not clickable
  RESUBMITTED_PROJECT: "resubmitted-project", // clickable to project ide
  RESUBMITTED_LEVEL_PROJECT: "resubmitted-level-project", // clickable to project ide
  ASSIGN_CLASSROOM: "assign-classroom", // clickable to project ide
};

export const IDE_TYPE = {
  WEB: "web",
  PYTHON: "python",
  SMOOTHY: "smoothy",
};

export const LESSON_TYPES = [
  { label: "code", value: "code" },
  { label: "challenge", value: "challenge" },
  { label: "graduation", value: "graduation" },
  { label: "playground_projects", value: "playground" },
];

export const CODE_SNIPPETS = {
  javascript: `\nfunction greet(name) {\n\tconsole.log("Hello, " + name + "!");\n}\n\ngreet("Alex");\n`,
  typescript: `\ntype Params = {\n\tname: string;\n}\n\nfunction greet(data: Params) {\n\tconsole.log("Hello, " + data.name + "!");\n}\n\ngreet({ name: "Alex" });\n`,
  python: `\ndef greet(name):\n\tprint("Hello, " + name + "!")\n\ngreet("Alex")\n`,
  java: `\npublic class HelloWorld {\n\tpublic static void main(String[] args) {\n\t\tSystem.out.println("Hello World");\n\t}\n}\n`,
  csharp:
    'using System;\n\nnamespace HelloWorld\n{\n\tclass Hello { \n\t\tstatic void Main(string[] args) {\n\t\t\tConsole.WriteLine("Hello World in C#");\n\t\t}\n\t}\n}\n',
  php: "<?php\n\n$name = 'Alex';\necho $name;\n",
  html: `\n<!DOCTYPE html>\n<html lang="en">\n<head>\n\t<meta charset="UTF-8">\n\t<title>Hello World</title>\n</head>\n<body>\n\t<h1>Hello, World!</h1>\n</body>\n</html>\n`, // Add HTML snippet
  css: `\nbody {\n\tbackground-color: #f0f0f0;\n\tcolor: #333;\n\tfont-family: Arial, sans-serif;\n}\n\nh1 {\n\tcolor: #007bff;\n}\n`, // Add CSS snippet
};
